import {Component, computed, inject, signal, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MatCheckboxModule} from "@angular/material/checkbox"
import {MatDialogModule, MatDialogRef, MatDialogTitle} from "@angular/material/dialog"
import {MatInputModule} from "@angular/material/input"
import {MatRadioModule} from "@angular/material/radio"
import {MatSelectModule} from "@angular/material/select"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-upload-mesh-dialog",
    templateUrl: "./upload-mesh-dialog.component.html",
    styleUrls: ["./upload-mesh-dialog.component.scss"],
    imports: [
        MatDialogTitle,
        MatDialogModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        FormsModule,
    ],
})
export class UploadMeshDialogComponent {
    readonly $consolidate = signal(false)
    readonly $selectedScaleOption = signal<"inputScale" | "customScale">("inputScale")
    readonly $inputScale = signal<"cm" | "m" | "mm" | "in">("cm")
    readonly $customScale = signal(1.0)
    readonly $scaleUv0 = signal(false)
    readonly $center = signal(true)
    readonly $convertToWorldSpaceUvs = signal(false)
    readonly formBuilder = inject(UntypedFormBuilder)
    readonly dialogRef = inject(MatDialogRef<UploadMeshDialogComponent>)
    readonly $scaleFactor = computed(() => {
        if (this.$selectedScaleOption() === "customScale") {
            return this.$customScale() === 1.0 ? undefined : this.$customScale()
        } else {
            switch (this.$inputScale()) {
                case "cm":
                    return undefined
                case "m":
                    return 100.0
                case "mm":
                    return 0.01
                case "in":
                    return 2.54
            }
        }
    })

    confirmAction(): void {
        this.dialogRef.close({
            consolidate: this.$consolidate(),
            scaleFactor: this.$scaleFactor(),
            scaleUv0: this.$scaleFactor() !== undefined ? this.$scaleUv0() : undefined,
            center: this.$center(),
            convertToWorldSpaceUvs: this.$convertToWorldSpaceUvs(),
        })
    }

    cancelAction(): void {
        this.dialogRef.close(false)
    }
}

export type UploadMeshDialogResult = {
    consolidate: boolean
    center: boolean
    scaleFactor?: number
    scaleUv0?: boolean
    convertToWorldSpaceUvs: boolean
}
